import {
  FINISH_LOADING_APPLICATION,
  SET_SIMULATED_USER_DETAILS,
  SET_USER_DETAILS,
  START_LOADING_APPLICATION,
} from "../action";
import { setUserPreferences } from "../api/api";
import loadTranslatedTexts from "./load-translated-texts";

export const setUserPreferenceLocale =
  (userPreference, isSimulateMode) => async (dispatch) => {
    dispatch({ type: START_LOADING_APPLICATION });
    try {
      const response = await setUserPreferences(userPreference, isSimulateMode);
      if (response && (response.status === 200 || response.status === 201)) {
        if (isSimulateMode)
          dispatch({
            type: SET_SIMULATED_USER_DETAILS,
            payload: { locale: userPreference.preferenceValue },
          });
        else
          dispatch({
            type: SET_USER_DETAILS,
            payload: { locale: userPreference.preferenceValue },
          });
        dispatch(loadTranslatedTexts(userPreference.preferenceValue));
      }
    } catch (error) {
      console.error("Error while setting User Preferences:", error);
      throw error;
    } finally {
      dispatch({ type: FINISH_LOADING_APPLICATION });
    }
  };

export default setUserPreferenceLocale;
